import { Component, ViewContainerRef } from "@angular/core";

import { ModalDialogService } from "./modals/modaldialog/modaldialog.service";

@Component({
  selector: "app-root",
  template: "<router-outlet></router-outlet>",
})
export class AppComponent {
  constructor(private viewContainerRef: ViewContainerRef, private modalDialogService: ModalDialogService) {
    this.modalDialogService.setViewContainer(this.viewContainerRef);
  }
}
